<template>
  <div>
    <!-- content -->
    <div class="content--block">
      <!-- all news -->
      <div class="content--articles">
        <div class="content--articles-main-block">
          <h1 class="content--articles-heading">News</h1>
        </div>

        <div class="article--recommended article--recommended---full-list">
          <!-- single news -->
          <div class="article--recommended-item" v-for="newItem in news">
            <div class="article--recommended-item-content">
              <router-link
                class="article--recommended-item-heading"
                :to="{ path: '/p/news/' + newItem.permalink}"
              >
                <span>{{ newItem.title }}</span>
              </router-link>
              <div class="article--recommended-item-bottom">
                <p
                  class="article--recommended-item-publish-date"
                >{{ newItem.publishedAt | UTCToDate }}</p>
                <router-link
                  class="article--recommended-item-cta"
                  :to="{ path: '/p/news/' + newItem.permalink}"
                >
                  <p>More</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    class
                  >
                    <path d="M6 0L4.94 1.06l4.19 4.19H0v1.5h9.13l-4.19 4.19L6 12l6-6-6-6"></path>
                  </svg>
                </router-link>
              </div>
            </div>
          </div>
          <!--/. single news -->
        </div>
        <!--/. all news -->
      </div>
    </div>
    <!--/. content -->
  </div>
</template>
<script>
import * as api from "../modules/api.js";
var _ = require("lodash");

export default {
  name: "news",
  data: function() {
    return {
      news: null
    };
  },
  mounted() {
    let me = this;
    api.request(api.newsList).then(function(news) {
      me.news = news;
    });
  },
  computed: {
    // a computed getter
    rows: function() {
      return _.chunk(this.news, 2);
    }
  },
  methods: {
    shortNew: function(newsContent) {
      return newsContent.split("<p>&lt;!--more--&gt;</p>")[0];
    },
    longNew: function(newsContent) {
      return newsContent.split("<p>&lt;!--more--&gt;</p>")[1];
    }
  }
};
</script>